import type { PaymentPlatform } from '../types'
import type { Product, SubscriptionProduct } from './types'

export interface MonthlyNoTrialConfig {
  product_id: number
  sku: string
}

export type DeployEnv = 'production' | 'staging' | 'dev'

export const MONTHLY_NO_TRIAL: Record<
  DeployEnv,
  Record<PaymentPlatform, MonthlyNoTrialConfig | null>
> = {
  production: {
    ios: { product_id: 64, sku: 'forest_monthly_early_bird_2' },
    googleplay_android: {
      product_id: 64,
      sku: 'forest_plus-monthly-early-bird-2',
    },
    china_android: null,
  },
  staging: {
    ios: { product_id: 68, sku: 'forest_monthly_early_bird_2' },
    googleplay_android: {
      product_id: 68,
      sku: 'forest_plus-monthly-early-bird-2',
    },
    china_android: null,
  },
  dev: {
    ios: { product_id: 57, sku: 'forest_monthly_early_bird_2' },
    googleplay_android: {
      product_id: 57,
      sku: 'forest_plus-monthly-early-bird-2',
    },
    china_android: null,
  },
}

export function buildMonthlyNoTrial(
  config: MonthlyNoTrialConfig,
  subscriptionProducts: SubscriptionProduct[],
): Product {
  const nativeProduct = subscriptionProducts.find((p) => p.sku === config.sku)
  return {
    product_id: config.product_id,
    receipt_system_product_id: 0,
    sku: config.sku,
    product_type: 'subscription',
    duration: 'monthly',
    eligible_trial_days: 0,
    offers: nativeProduct?.offers,
    price_localized: nativeProduct?.price_localized ?? '',
    price_value: nativeProduct?.price_value ?? 0,
    display_name: nativeProduct?.display_name ?? '',
  }
}
